import type { GroupDetailUI, GroupListRaw, GroupRow, GroupUserRaw, GroupUserRow } from "~/features/admin/groups/types";

function toGroupRow(raw: GroupListRaw): GroupRow {
  return {
    id: raw.id,
    name: raw.name,
    description: raw.description ?? "",
    isDeactivated: Boolean(raw.deactivatedAt),
  };
}

export function toGroupRowList(raws: readonly GroupListRaw[]): GroupRow[] {
  return raws.map(toGroupRow);
}

export function toGroupDetailUI(raw: GroupListRaw): GroupDetailUI {
  return {
    id: raw.id,
    name: raw.name,
    description: raw.description ?? "",
    createdAt: raw.createdAt,
    updatedAt: raw.updatedAt,
    deactivatedAt: raw.deactivatedAt ?? null,
    isDeactivated: Boolean(raw.deactivatedAt),
  };
}

function toGroupUserRow(raw: GroupUserRaw): GroupUserRow {
  return {
    id: raw.id,
    displayName: raw.displayName ?? "",
    email: raw.email,
    segments: raw.userUserSegments.map((uus) => uus.userSegment.name),
    isDeactivated: Boolean(raw.deactivatedAt),
  };
}

export function toGroupUserRowList(raws: readonly GroupUserRaw[]): GroupUserRow[] {
  return raws.map(toGroupUserRow);
}
